import styled from 'styled-components'

export const Panel = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const SpinnerContainer = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`
